import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {DataStore} from '@aws-amplify/datastore';
import {Contract} from '../../../models';

@Component({
  selector: 'app-client-home-menu',
  templateUrl: './client-home-menu.component.html',
  styleUrls: ['./client-home-menu.component.scss'],
})
export class ClientHomeMenuComponent implements OnInit {

  contractsCount: number;
  cssClass: any;
  productsCount: any;

  constructor(
    private router: Router,
    private sessionService: SessionService,
    ) { }

  async ngOnInit() {
    const currentUser =  this.sessionService.getCurrentUser();
    this.contractsCount =  (await DataStore.query(Contract)).filter(c => c.clientId == currentUser?.id).length;
  }

  openPage(page: string) {
    return this.router.navigate([page]);
  }

}
